import { logger } from '@shared-services/log-service';
import { CalEventData } from '../types';

class CalApi {
    static CAL_API_VERSION = '2024-08-13';

    private calApiDomain: string = 'api.cal.com';
    private calClientId: string = '';

    get apiUrl() {
        return `https://${this.calApiDomain}/v2`;
    }

    public setCalDomain(domain: string = 'api.cal.com') {
        this.calApiDomain = domain;
    }

    public setCalClientId(clientId: string) {
        this.calClientId = clientId;
    }

    async fetchCalCom(url: string, options: object) {
        const res = await fetch(calApi.apiUrl + url, options);
        const jsonRes = await res.json();
        return jsonRes.data || jsonRes;
    }

    async cancelBooking(bookingUid: string, cancellationReason?: string) {
        const url = `/bookings/${bookingUid}/cancel`;
        try {
            const options = {
                method: 'POST',
                headers: {
                    'cal-api-version': CalApi.CAL_API_VERSION,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    cancellationReason,
                }),
            };
            const res = await this.fetchCalCom(url, options);
            if (res.error) {
                throw new Error(res.error?.message || res.error);
            }
            return res;
        } catch (e) {
            logger.error({
                message: `Failed to cancel booking with UID: ${bookingUid}`,
                errorMessage: e?.toString(),
                url,
                tags: ['cal-booking', 'cancel-booking'],
            });
            throw e;
        }
    }

    async getBooking(bookingUid: string) {
        const url = `/bookings/${bookingUid}`;
        return await this.fetchCalCom(url, {
            method: 'GET',
        });
    }

    async getTeamEvents({
        organizationId,
        teamId,
    }: {
        organizationId: number;
        teamId: number;
    }): Promise<CalEventData[]> {
        const url = `/organizations/${organizationId}/teams/${teamId}/event-types`;
        return await this.fetchCalCom(url, {
            method: 'GET',
            headers: {
                'x-cal-client-id': this.calClientId,
                'cal-api-version': CalApi.CAL_API_VERSION,
                'Content-Type': 'application/json',
            },
        });
    }

    async getTeamEventType({
        eventSlug,
        orgId,
        teamId,
    }: {
        eventSlug: string;
        orgId: number;
        teamId: number;
    }) {
        const url = `/atoms/event-types/${eventSlug}/public?isTeamEvent=true&teamId=${teamId}&username=&orgId=${orgId}`;
        return await this.fetchCalCom(url, {
            method: 'GET',
            headers: {
                'x-cal-client-id': this.calClientId,
                'cal-api-version': CalApi.CAL_API_VERSION,
                'Content-Type': 'application/json',
            },
        });
    }
}

const calApi = new CalApi();

export default calApi;
